import { routes } from '@/config/routes';

export type CategoryPresentation = {
  eyebrow: string;
  heroMessage: string;
  customizationNotes: string[];
  icon: string;
  route: string;
  shortTitle: string;
};

export const categoryPresentation: Record<string, CategoryPresentation> = {
  'wood-engraving': {
    eyebrow: 'Naturally meaningful',
    heroMessage: 'A lasting story, thoughtfully etched in wood.',
    customizationNotes: [
      'Add names, dates, messages, or artwork.',
      'Preview guidance will arrive with the M4 customizer.',
      'Natural grain makes every finished piece subtly unique.',
    ],
    icon: 'pi pi-box',
    route: routes.woodEngraving,
    shortTitle: 'Wood Engraving',
  },
  ornaments: {
    eyebrow: 'Traditions made personal',
    heroMessage: 'Give every holiday memory a place on the tree.',
    customizationNotes: [
      'Personalize names, milestones, and short messages.',
      'Seasonal availability will be confirmed before ordering.',
      'The guided ornament customizer is planned for M5.',
    ],
    icon: 'pi pi-star',
    route: routes.ornaments,
    shortTitle: 'Ornaments',
  },
  tshirts: {
    eyebrow: 'Wear the moment',
    heroMessage: 'Turn your idea into something everyone can wear.',
    customizationNotes: [
      'Add photos, artwork, event details, or team names.',
      'Final garment colors and size guides will be product-specific.',
      'The apparel design tool is planned for M6.',
    ],
    icon: 'pi pi-palette',
    route: routes.tshirts,
    shortTitle: 'Custom T-Shirts',
  },
};

export function presentationForCategory(slug: string, name: string): CategoryPresentation {
  return (
    categoryPresentation[slug] ?? {
      eyebrow: 'Made personal',
      heroMessage: `Explore personalized ${name.toLocaleLowerCase()}.`,
      customizationNotes: ['Product-specific personalization details are shown on each product.'],
      icon: 'pi pi-sparkles',
      route: `${routes.products}/${slug}`,
      shortTitle: name,
    }
  );
}
